import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "18",
  fill: "none",
  viewBox: "0 0 19 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M5 15q-.618 0-1.06-.441A1.44 1.44 0 0 1 3.5 13.5V12q0-.319.216-.535a.72.72 0 0 1 .534-.215q.318 0 .535.216A.72.72 0 0 1 5 12v1.5h9V12q0-.319.216-.535a.72.72 0 0 1 .534-.215q.319 0 .535.216A.72.72 0 0 1 15.5 12v1.5q0 .619-.441 1.06Q14.618 15 14 15zm3.75-9.112L7.344 7.294a.7.7 0 0 1-.535.216.76.76 0 0 1-.534-.235.8.8 0 0 1-.216-.525.69.69 0 0 1 .216-.525l2.7-2.7a.65.65 0 0 1 .244-.159.85.85 0 0 1 .562 0 .7.7 0 0 1 .244.159l2.7 2.7q.225.225.216.525a.766.766 0 0 1-.75.76.7.7 0 0 1-.535-.216L10.25 5.888v5.362q0 .319-.216.535A.72.72 0 0 1 9.5 12a.73.73 0 0 1-.535-.216.72.72 0 0 1-.215-.534z"
    }, null, -1)
  ]))]))
}
export default { render: render }